export interface Paper {
  title: string
  venue: string
  year: string
  area: 'Artificial General Intelligence' | 'Virtual Agent Control'
  href: string
}

export const papers: Paper[] = [
  {
    title: 'Toward a Formal Characterization of Real-World General Intelligence',
    venue: 'Conference on Artificial General Intelligence',
    year: '2023',
    area: 'Artificial General Intelligence',
    href: '#',
  },
  {
    title: 'Integrative Architectures for Cognitive Synergy in Learning Systems',
    venue: 'Journal of Artificial General Intelligence',
    year: '2022',
    area: 'Artificial General Intelligence',
    href: '#',
  },
  {
    title: 'Goal-Directed Action Selection for Embodied Virtual Agents',
    venue: 'Workshop on Intelligent Virtual Agents',
    year: '2021',
    area: 'Virtual Agent Control',
    href: '#',
  },
  {
    title: 'Learning Motor Schemata for Controllable Agents in Simulated Worlds',
    venue: 'International Conference on Autonomous Agents',
    year: '2020',
    area: 'Virtual Agent Control',
    href: '#',
  },
]

export const researchAreas: { title: string; note: string; published: boolean }[] = [
  {
    title: 'Artificial General Intelligence',
    note: 'Long-term work on architectures for general, transferable machine intelligence.',
    published: true,
  },
  {
    title: 'Virtual agent control',
    note: 'Action selection and embodied behavior for agents operating in simulated environments.',
    published: true,
  },
  {
    title: 'Pattern recognition',
    note: 'Applied detection and classification work conducted under client confidentiality.',
    published: false,
  },
  {
    title: 'Data analysis',
    note: 'Practical methods developed inside engagements and retained as proprietary technique.',
    published: false,
  },
  {
    title: 'Natural language processing',
    note: 'Retrieval, extraction, and language understanding work that remains largely undiscussed publicly.',
    published: false,
  },
]
